import styled from 'styled-components'

export const StyledMain = styled.main`
  padding-bottom: var(--footer-min-height);
  background-color: var(--background-primary);
`
